import { getLogger } from '@jitsi/logger';
import React from 'react';

import { MEDIA_TYPE } from '../../react/features/base/media/constants';
import { updateSettings } from '../../react/features/base/settings/actions';
import { getLocalJitsiVideoTrack } from '../../react/features/base/tracks/functions';
import { muteLocal } from '../../react/features/video-menu/actions.any';
import { showCustomNotification } from '../components/notifications';

import CameraControll from './CameraControll';
import { NotificationTemplate, WizyconfNotification } from './components/notifications';

const logger = getLogger(__filename);


import {
    CAMERA_ICON_CLASSNAME,
    CAMERA_OFF_CLASSNAME,
    CAMERA_OFF_ICON_CLASSNAME,
    CAMERA_ON_CLASSNAME,
    FOUR_K_CAMERA_ICON_CLASSNAME,
    NOTIFICATION_HIDE_TIMEOUT,
    PTZ_CAMERA_ICON_CLASSNAME,
    WIZYCONF_4K_CAMERA,
    WIZYCONF_PTZ_CAMERA
} from './constants';


export default class CameraActions {

    constructor() {
        this.notificationData = [
            {
                camModel: WIZYCONF_4K_CAMERA,
                titleTranslation: 'strings.4kCamera',
                icon: FOUR_K_CAMERA_ICON_CLASSNAME
            },
            {
                camModel: WIZYCONF_PTZ_CAMERA,
                titleTranslation: 'strings.PTZCamera',
                icon: PTZ_CAMERA_ICON_CLASSNAME
            }
        ];
    }

    showCameraOnNotification(label) {
        let icon, title;
        const data = this.notificationData.find(i => label.toLowerCase().indexOf(i.camModel) !== -1);

        if (data) {
            title = data.titleTranslation;
            icon = data.icon;
        } else {
            const match = label.match(/(.*) \(.*\)/);

            title = (match && match[1]) || 'strings.Camera';
            icon = CAMERA_ICON_CLASSNAME;
        }

        APP.store.dispatch(showCustomNotification({
            titleKey: title,
            customClass: CameraControll.PTZ_CONTROL_ENABLED ? 'animate' : '',
            description:
                <NotificationTemplate key={0} firstLine={{ text: 'strings.On' }}
                    iconClass={`${CAMERA_ON_CLASSNAME} ${icon}`}/>
        }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));
        logger.log('showCameraOnNotification', title);
    }

    isLocalVideoStreamMuted() {
        const localVideo = getLocalJitsiVideoTrack(APP.store.getState());

        if (APP.conference.isSharingScreen) {
            return true;
        } else if (localVideo) {
            return localVideo.isMuted();
        }

        return true;
    }

    changeMode() {
        const webcams = APP.store.getState()['features/base/devices'].availableDevices.videoInput;
        const cameraDeviceId = APP.store.getState()['features/base/settings'].cameraDeviceId;

        APP.conference.wIsLocalVideoMuted = null;
        APP.conference.wCanUpdateList = true;
        CameraControll.CAMERA_TOGGLED = false;

        if (this.isLocalVideoStreamMuted()) {
            if (webcams.length === 0) {
                return;
            }
            APP.conference.wIsLocalVideoMuted = false;
            APP.conference.onVideoDeviceChanged(webcams[0].deviceId);
            this.showCameraOnNotification(webcams[0].label);
            APP.store.dispatch(muteLocal(false, MEDIA_TYPE.VIDEO));
            APP.store.dispatch(updateSettings({
                userSelectedCameraDeviceId: webcams[0].deviceId,
                userSelectedCameraDeviceLabel: webcams[0].label
            }));

            return;
        }
        let activeWebcamPos = webcams.findIndex(d => d.deviceId === cameraDeviceId);

        if (activeWebcamPos === webcams.length - 1) {
            APP.store.dispatch(showCustomNotification({
                titleKey: 'strings.Camera',
                description:
                    <NotificationTemplate key={0} firstLine={{ text: 'strings.Off',
                        color: 'color-gray' }}
                    iconClass={`${CAMERA_OFF_CLASSNAME} ${CAMERA_OFF_ICON_CLASSNAME}`}/>
            }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));

            APP.store.dispatch(muteLocal(true, MEDIA_TYPE.VIDEO));
            logger.log('showCameraOffNotification');
        } else {
            activeWebcamPos++;
            APP.conference.onVideoDeviceChanged(webcams[activeWebcamPos].deviceId);
            this.showCameraOnNotification(webcams[activeWebcamPos].label);

            APP.store.dispatch(updateSettings({
                userSelectedCameraDeviceId: webcams[activeWebcamPos].deviceId,
                userSelectedCameraDeviceLabel: webcams[activeWebcamPos].label
            }));
            CameraControll.CAMERA_TOGGLED = true;
            window.dispatchEvent(new CustomEvent('cameraControlDisable'));
        }
    }
}
